export function formatConfidence(confidence: number | null | undefined): string {
  return confidence != null ? `${Math.round(confidence * 100)}%` : '0%';
}
